import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import {
    Box,
    Drawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListItemButton,
    useTheme,
    Typography
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsIcon from '@mui/icons-material/Settings';
import { useAuth } from '../../contexts/AuthContext';

const drawerWidth = 240;

interface MenuItem {
    text: string;
    path: string;
    icon: React.ReactNode;
    requireAdmin?: boolean;
}

const menuItems: MenuItem[] = [
    { text: 'Dashboard', path: '/admin/dashboard', icon: <DashboardIcon />, requireAdmin: true },
    { text: 'Customers', path: '/admin/customers', icon: <PeopleIcon />, requireAdmin: true },
    { text: 'Coupons', path: '/admin/coupons', icon: <LocalOfferIcon />, requireAdmin: true },
    { text: 'Assets', path: '/admin/assets', icon: <PermMediaIcon />, requireAdmin: true },
    { text: 'Reports', path: '/admin/reports', icon: <BarChartIcon />, requireAdmin: true },
    { text: 'Settings', path: '/admin/settings', icon: <SettingsIcon />, requireAdmin: true },
];

const Sidebar = () => {
    const theme = useTheme();
    const location = useLocation();
    const { user } = useAuth();

    const isAdmin = user?.role === 'admin';

    const filteredMenuItems = menuItems.filter(item => !item.requireAdmin || isAdmin);

    return (
        <Drawer
            variant="permanent"
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: drawerWidth,
                    boxSizing: 'border-box',
                    backgroundColor: (theme) => theme.palette.background.default,
                    borderRight: '1px solid',
                    borderColor: 'divider'
                },
            }}
        >
            <Box sx={{ p: 2, pt: 3, display: 'flex', justifyContent: 'center' }}>
                <Box
                    component="img"
                    src="/qrpon-logo-200x216.png"
                    alt="qrPON Logo"
                    sx={{
                        width: 'auto',
                        height: '120px',
                        display: 'block'
                    }}
                />
            </Box>
            <Box sx={{ overflow: 'auto', mt: 0 }}>
                <List>
                    {filteredMenuItems.map((item) => (
                        <ListItem key={item.text} disablePadding>
                            <ListItemButton
                                component={Link}
                                to={item.path}
                                selected={location.pathname === item.path}
                                sx={{
                                    '&.Mui-selected': {
                                        bgcolor: 'action.selected',
                                    },
                                    '&:hover': {
                                        bgcolor: 'action.hover',
                                    },
                                }}
                            >
                                <ListItemIcon sx={{ color: 'text.secondary' }}>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText primary={item.text} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Drawer>
    );
};

export default Sidebar;
